// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bhu_a bik_ea bik_a","LoadingSwitch__init":"bhu_b bik_a bik_w bik_j bik_ul bik_um bik_fm"};